import { Component } from 'react';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

class LoanpartOverviewHeaderComponent extends Component {
  render() {
    const { activeTabName, CalculationFormData } = this.props;
    const selectedLabelName = CalculationFormData.selectedLabelName;

    return (
      <div className="calculation-container__loanpart-overview-intro">
        <span className="bold">{activeTabName}</span> {selectedLabelName}
      </div>
    );
  }
}

LoanpartOverviewHeaderComponent.propTypes = {
  activeTabName: PropTypes.string,
  CalculationFormData: PropTypes.shape({
    selectedLabelName: PropTypes.string,
  }),
};

LoanpartOverviewHeaderComponent.defaultProps = {
  activeTabName: '',
  CalculationFormData: {
    selectedLabelName: '',
  },
};

export default inject('CalculationFormData')(LoanpartOverviewHeaderComponent);
